var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.68237 22.528V18.8587C7.68237 17.9221 8.42041 17.1628 9.33082 17.1628H12.6588C13.096 17.1628 13.5153 17.3414 13.8244 17.6595C14.1336 17.9776 14.3073 18.4089 14.3073 18.8587V22.528C14.3045 22.9174 14.4529 23.2918 14.7196 23.5682C14.9863 23.8446 15.3491 24 15.7276 24H17.9981C19.0585 24.0028 20.0765 23.5714 20.8272 22.801C21.578 22.0305 22 20.9844 22 19.8934V9.44023C22 8.55895 21.6203 7.72301 20.9632 7.1576L13.2394 0.811042C11.8958 -0.301726 9.97076 -0.265797 8.66729 0.896374L1.1197 7.1576C0.431594 7.70634 0.0203237 8.54476 0 9.44023V19.8827C0 22.1566 1.7917 24 4.00188 24H6.22055C7.00668 24 7.64558 23.3474 7.65127 22.5387L7.68237 22.528Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.77e42048b342bfb922f6b87c3d363290.svg";
export { ForwardRef as ReactComponent };